import { useEffect, useState } from 'react';

export default function useKernelBoot({ lineCount, durationMs, onComplete }) {
    const [visibleLines, setVisibleLines] = useState(0);

    useEffect(() => {
        const interval = durationMs / lineCount;

        const t = setInterval(() => {
            setVisibleLines(v => {
                if (v + 1 >= lineCount) {
                    clearInterval(t);
                    onComplete && onComplete();
                    return lineCount;
                }
                return v + 1;
            });
        }, interval);

        return () => clearInterval(t);
    }, [lineCount, durationMs, onComplete]);

    return visibleLines;
}
